module.exports = __webpack_public_path__ + "menu_2_active.752c8854.png";